/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  APITemporaryToken,
  ContentKitRenderOutput,
  EntityId,
  InstalledIntegration,
  Integration,
  IntegrationCategory,
  IntegrationEvent,
  IntegrationEventTrace,
  IntegrationInstallation,
  IntegrationInstallationStatus,
  IntegrationScope,
  IntegrationSiteInstallation,
  IntegrationSpaceInstallation,
  IntegrationTarget,
  List,
  OrganizationTarget,
  PublishIntegration,
  RenderIntegrationUI,
  SiteIntegrationScript,
  UpdateIntegrationInstallation,
  UpdateIntegrationSiteInstallation,
  UpdateIntegrationSpaceInstallation,
} from "./data-contracts";

/**
 * @description Returns a paginated list of the integrations published in the GitBook marketplace. Use this to discover an integration by name, category, or the blocks and content sources it provides, before installing it on an organization, space or site.
 * @tags integrations
 * @name ListIntegrations
 * @summary List all public integrations
 * @request GET:/integrations
 * @secure
 */

// @ts-ignore
export const listIntegrations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** A search string to filter integrations by name */
    search?: string;
    /** Filter the integrations by category */
    category?: IntegrationCategory;
    /**
     * Filter the integrations by block's domains
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    blockDomain?: string;
    /** If true, returns only integrations with blocks. If false, returns only integrations without blocks. */
    blocks?: boolean;
    /** If true, returns only integrations with contentSources. If false, returns only integrations without contentSources. */
    contentSources?: boolean;
    /** If defined, only list integrations owned by the given organization. */
    owner?: string;
    /** Filter the integrations by scope */
    scope?: IntegrationScope;
    /** Filter the integrations by target */
    target?: IntegrationTarget;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Integration[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/integrations",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a single integration by its unique name, including the configuration it expects, the targets it can be installed on, and the permissions it requests. Private integrations are only readable by the organization that owns them.
 * @tags integrations
 * @name GetIntegrationByName
 * @summary Get an integration by its name
 * @request GET:/integrations/{integrationName}
 * @secure
 */

// @ts-ignore
export const getIntegrationByName: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Integration;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/integrations/{integrationName}",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name PublishIntegration
 * @summary Publish an integration
 * @request POST:/integrations/{integrationName}
 * @secure
 */

// @ts-ignore
export const publishIntegration: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: PublishIntegration;
  RequestHeaders: {};
  ResponseBody: Integration;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/integrations/{integrationName}",
  method: "post",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name UnpublishIntegration
 * @summary Unpublish an integration
 * @request DELETE:/integrations/{integrationName}
 * @secure
 */

// @ts-ignore
export const unpublishIntegration: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/integrations/{integrationName}",
  method: "delete",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name ListIntegrationInstallations
 * @summary List all integration installations
 * @request GET:/integrations/{integrationName}/installations
 * @secure
 */

// @ts-ignore
export const listIntegrationInstallations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** External Id to filter by */
    externalId?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: IntegrationInstallation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/installations",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Installs an integration on an organization, creating the account-level installation that space and site installations hang off. Configure it with the update operation, then enable it on individual spaces or sites.
 * @tags integrations
 * @name InstallIntegration
 * @summary Install an integration
 * @request POST:/integrations/{integrationName}/installations
 * @secure
 */

// @ts-ignore
export const installIntegration: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: OrganizationTarget;
  RequestHeaders: {};
  ResponseBody: IntegrationInstallation;
  ResponseStatusCode: 201 | 404;
} = {
  route: "/integrations/{integrationName}/installations",
  method: "post",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name ListIntegrationEvents
 * @summary List all integration events
 * @request GET:/integrations/{integrationName}/events
 * @secure
 */

// @ts-ignore
export const listIntegrationEvents: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: IntegrationEvent[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/events",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name GetIntegrationEvent
 * @summary Get an integration event by its ID
 * @request GET:/integrations/{integrationName}/events/{eventId}
 * @secure
 */

// @ts-ignore
export const getIntegrationEvent: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** ID of the integration event */
    eventId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    event: IntegrationEvent;
    trace?: IntegrationEventTrace;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/integrations/{integrationName}/events/{eventId}",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name ListIntegrationSpaceInstallations
 * @summary List all integration space installations
 * @request GET:/integrations/{integrationName}/spaces
 * @secure
 */

// @ts-ignore
export const listIntegrationSpaceInstallations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** External Id to filter by */
    externalId?: string;
    /**
     * If true, returns the space object in each items. If false, returns the space ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: IntegrationSpaceInstallation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/spaces",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name ListIntegrationSiteInstallations
 * @summary List all integration site installations
 * @request GET:/integrations/{integrationName}/sites
 * @secure
 */

// @ts-ignore
export const listIntegrationSiteInstallations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** External ID to filter by */
    externalId?: string;
    /**
     * If true, returns the site object in each items. If false, returns the site ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: IntegrationSiteInstallation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/sites",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name SetIntegrationDevelopmentMode
 * @summary Enable integration dev mode
 * @request PUT:/integrations/{integrationName}/dev
 * @secure
 */

// @ts-ignore
export const setIntegrationDevelopmentMode: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * URL of the tunnel to dispatch integration events to
     * @minLength 1
     * @maxLength 256
     */
    tunnelUrl: string;
    /**
     * If set to true, all requests will be forwarded to the tunnel, not just from the owning organization.
     * @default false
     */
    all?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/integrations/{integrationName}/dev",
  method: "put",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name DisableIntegrationDevelopmentMode
 * @summary Disable integration dev mode
 * @request DELETE:/integrations/{integrationName}/dev
 * @secure
 */

// @ts-ignore
export const disableIntegrationDevelopmentMode: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205;
} = {
  route: "/integrations/{integrationName}/dev",
  method: "delete",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name RenderIntegrationUiWithGet
 * @summary Render an integration UI with GET method
 * @request GET:/integrations/{integrationName}/render
 * @secure
 */

// @ts-ignore
export const renderIntegrationUIWithGet: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {
    /** LZ-string compressed JSON request */
    request: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ContentKitRenderOutput;
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/render",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name RenderIntegrationUiWithPost
 * @summary Render an integration UI with POST method
 * @request POST:/integrations/{integrationName}/render
 * @secure
 */

// @ts-ignore
export const renderIntegrationUIWithPost: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: RenderIntegrationUI;
  RequestHeaders: {};
  ResponseBody: ContentKitRenderOutput;
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/render",
  method: "post",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name QueueIntegrationTask
 * @summary Queue an integration task
 * @request POST:/integrations/{integrationName}/tasks
 * @secure
 */

// @ts-ignore
export const queueIntegrationTask: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Payload for the integration task */
    task: object;
    /**
     * Number of seconds to wait before executing the task, defaults to 0
     * @min 0
     * @max 86400
     */
    schedule?: number;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/integrations/{integrationName}/tasks",
  method: "post",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the organization-level installation of an integration, including its account configuration and how many spaces it manages. The configuration can contain credentials the integration stored for third-party services.
 * @tags integrations
 * @name GetIntegrationInstallationById
 * @summary Get an integration installation by its ID
 * @request GET:/integrations/{integrationName}/installations/{installationId}
 * @secure
 */

// @ts-ignore
export const getIntegrationInstallationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: IntegrationInstallation;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/integrations/{integrationName}/installations/{installationId}",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates the account-level configuration of an installation, and which spaces or sites it applies to.
 * @tags integrations
 * @name UpdateIntegrationInstallation
 * @summary Update an integration installation
 * @request PATCH:/integrations/{integrationName}/installations/{installationId}
 * @secure
 */

// @ts-ignore
export const updateIntegrationInstallation: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: UpdateIntegrationInstallation;
  RequestHeaders: {};
  ResponseBody: IntegrationInstallation;
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/installations/{installationId}",
  method: "patch",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name UninstallIntegration
 * @summary Uninstall an integration
 * @request DELETE:/integrations/{integrationName}/installations/{installationId}
 * @secure
 */

// @ts-ignore
export const uninstallIntegration: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/integrations/{integrationName}/installations/{installationId}",
  method: "delete",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a temporary API token of an integration's installation that has access to the installation and it's scopes. You must be authenticated as the integration to obtain this token.
 * @tags integrations
 * @name CreateIntegrationInstallationToken
 * @summary Create an integration installation API token
 * @request POST:/integrations/{integrationName}/installations/{installationId}/tokens
 * @secure
 */

// @ts-ignore
export const createIntegrationInstallationToken: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: APITemporaryToken;
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/tokens",
  method: "post",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of the spaces an installation is enabled on, with the configuration of the integration for each of them. Pass extended to get the full space object instead of its ID.
 * @tags integrations
 * @name ListIntegrationInstallationSpaces
 * @summary List all space integration installations
 * @request GET:/integrations/{integrationName}/installations/{installationId}/spaces
 * @secure
 */

// @ts-ignore
export const listIntegrationInstallationSpaces: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If true, returns the space object in each items. If false, returns the space ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: IntegrationSpaceInstallation[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/spaces",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Enables an existing organization-level installation on one space. The organization must already have the integration installed.
 * @name InstallIntegrationOnSpace
 * @summary Install an integration on a space
 * @request POST:/integrations/{integrationName}/installations/{installationId}/spaces
 * @secure
 */

// @ts-ignore
export const installIntegrationOnSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {
    /**
     * If true, returns the space object in each items. If false, returns the space ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: {
    /** ID of the space to install the integration on */
    space: string;
  };
  RequestHeaders: {};
  ResponseBody: IntegrationSpaceInstallation;
  ResponseStatusCode: 201 | 404;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/spaces",
  method: "post",
  streaming: false,
  tags: [],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the installation of an integration on one space, including the configuration of the integration for that space.
 * @tags integrations
 * @name GetIntegrationSpaceInstallation
 * @summary Get an integration space installation
 * @request GET:/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const getIntegrationSpaceInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /**
     * If true, returns the space object in each items. If false, returns the space ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: IntegrationSpaceInstallation;
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates the configuration of an integration for one space.
 * @tags integrations
 * @name UpdateIntegrationSpaceInstallation
 * @summary Update an integration space installation
 * @request PATCH:/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const updateIntegrationSpaceInstallation: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /**
     * If true, returns the space object in each items. If false, returns the space ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: UpdateIntegrationSpaceInstallation;
  RequestHeaders: {};
  ResponseBody: IntegrationSpaceInstallation;
  ResponseStatusCode: 200;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}",
  method: "patch",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name UninstallIntegrationFromSpace
 * @summary Uninstall an integration from a space
 * @request DELETE:/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const uninstallIntegrationFromSpace: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/spaces/{spaceId}",
  method: "delete",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of the sites an installation is enabled on, with the configuration of the integration for each of them. Pass extended to get the full site object instead of its ID.
 * @tags integrations
 * @name ListIntegrationInstallationSites
 * @summary List all site integration installations
 * @request GET:/integrations/{integrationName}/installations/{installationId}/sites
 * @secure
 */

// @ts-ignore
export const listIntegrationInstallationSites: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If true, returns the site object in each items. If false, returns the site ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: IntegrationSiteInstallation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/integrations/{integrationName}/installations/{installationId}/sites",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Enables an existing organization-level installation on one site. The organization must already have the integration installed.
 * @tags integrations
 * @name InstallIntegrationOnSite
 * @summary Install an integration on a site
 * @request POST:/integrations/{integrationName}/installations/{installationId}/sites
 * @secure
 */

// @ts-ignore
export const installIntegrationOnSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
  };
  RequestQuery: {
    /**
     * If true, returns the site object in each items. If false, returns the site ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: {
    /** ID of the site to install the integration on */
    siteId: string;
  };
  RequestHeaders: {};
  ResponseBody: IntegrationSiteInstallation;
  ResponseStatusCode: 201 | 404;
} = {
  route: "/integrations/{integrationName}/installations/{installationId}/sites",
  method: "post",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the installation of an integration on one site, including the configuration of the integration for that site.
 * @tags integrations
 * @name GetIntegrationSiteInstallation
 * @summary Get an integration site installation
 * @request GET:/integrations/{integrationName}/installations/{installationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const getIntegrationSiteInstallation: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /**
     * If true, returns the site object in each items. If false, returns the site ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: IntegrationSiteInstallation;
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/sites/{siteId}",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates the configuration of an integration for one site.
 * @tags integrations
 * @name UpdateIntegrationSiteInstallation
 * @summary Update an integration site installation
 * @request PATCH:/integrations/{integrationName}/installations/{installationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const updateIntegrationSiteInstallation: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /**
     * If true, returns the site object in each items. If false, returns the site ID in each items.
     * @default false
     */
    extended?: boolean;
  };
  RequestBody: UpdateIntegrationSiteInstallation;
  RequestHeaders: {};
  ResponseBody: IntegrationSiteInstallation;
  ResponseStatusCode: 200;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/sites/{siteId}",
  method: "patch",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name UninstallIntegrationFromSite
 * @summary Uninstall an integration from a site
 * @request DELETE:/integrations/{integrationName}/installations/{installationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const uninstallIntegrationFromSite: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
    /** Identifier of the installation */
    installationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route:
    "/integrations/{integrationName}/installations/{installationId}/sites/{siteId}",
  method: "delete",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of the integrations available to the organization: every publicly published integration plus the private ones the organization owns or is trusted with. Prefer this over the public listing when acting inside an organization.
 * @tags integrations
 * @name ListOrganizationIntegrations
 * @summary List all public integrations along with private ones trusted by the specific org.
 * @request GET:/orgs/{organizationId}/integrations
 * @secure
 */

// @ts-ignore
export const listOrganizationIntegrations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** A search string to filter integrations by name */
    search?: string;
    /** Filter the integrations by category */
    category?: IntegrationCategory;
    /**
     * Filter the integrations by block's domains
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    blockDomain?: string;
    /** If true, returns only integrations with blocks. If false, returns only integrations without blocks. */
    blocks?: boolean;
    /** If true, returns only integrations with contentSources. If false, returns only integrations without contentSources. */
    contentSources?: boolean;
    /** If defined, only list integrations owned by the given organization. */
    owner?: string;
    /** Filter the integrations by scope */
    scope?: IntegrationScope;
    /** Filter the integrations by target */
    target?: IntegrationTarget;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Integration[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/integrations",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns whether an integration is installed for the organization and the status of that installation. Use this for a single integration instead of listing every status.
 * @tags integrations
 * @name GetOrganizationIntegrationStatus
 * @summary Get the status of an integration
 * @request GET:/orgs/{organizationId}/integrations/{integrationName}/installation_status
 * @secure
 */

// @ts-ignore
export const getOrganizationIntegrationStatus: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    status: IntegrationInstallationStatus;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/orgs/{organizationId}/integrations/{integrationName}/installation_status",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags integrations
 * @name ListOrganizationInstallations
 * @summary List all integration installations
 * @request GET:/orgs/{organizationId}/installations
 * @secure
 */

// @ts-ignore
export const listOrganizationInstallations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** A search string to filter integrations by name */
    search?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      /** Installation of an integration on an account */
      installation: IntegrationInstallation;
      integration: Integration;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/installations",
  method: "get",
  streaming: false,
  tags: ["integrations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns integration installations in the organization. Use site or space with the matching target to efficiently scope the result to one resource. The target of each installation says whether it is installed on the organization, a space or a site.
 * @tags integrations, critical
 * @name ListOrganizationIntegrationsStatus
 * @summary List all integration statuses
 * @request GET:/orgs/{organizationId}/integrations/installations-status
 * @secure
 */

// @ts-ignore
export const listOrganizationIntegrationsStatus: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * Filter installations by their target (organization, space, or site). When not provided, defaults to organization-level installations for backwards compatibility
     * @default "organization"
     */
    target?: "organization" | "space" | "site";
    /** Return installations for this site. Only valid when target is site. */
    site?: string;
    /** Return installations for this space. Only valid when target is space. */
    space?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: InstalledIntegration[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/integrations/installations-status",
  method: "get",
  streaming: false,
  tags: ["integrations", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Returns all integration scripts configured to be injected into the published pages of a site, such as analytics trackers, chat widgets, or custom JavaScript. Use this to audit which third-party scripts are active on the site.
 * @tags integrations, sites
 * @name ListSiteIntegrationScripts
 * @summary List custom scripts injected into a site's published pages
 * @request GET:/orgs/{organizationId}/sites/{siteId}/integration-scripts
 * @secure
 */

// @ts-ignore
export const listSiteIntegrationScripts: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteIntegrationScript[];
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/integration-scripts",
  method: "get",
  streaming: false,
  tags: ["integrations", "sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of integrations currently enabled on the site. Integrations extend site functionality with third-party services such as analytics, support, or authentication providers. Use this to audit which integrations are active, or to find an integration before updating its settings.
 * @tags integrations, sites
 * @name ListSiteIntegrations
 * @summary List third-party integrations enabled on a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/integrations
 * @secure
 */

// @ts-ignore
export const listSiteIntegrations: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** A search string to filter integrations by name */
    search?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Integration[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/integrations",
  method: "get",
  streaming: false,
  tags: ["integrations", "sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
